import { Injectable } from '@angular/core';

import { getFirebaseBackend } from '../../authUtils';

import { User } from '../models/auth.models';

@Injectable({ providedIn: 'root' })

export class AuthenticationService {

    user: User;

    constructor() {
    }

    /**
     * Returns the current user
     */
    public currentUser(): User {
        let user = getFirebaseBackend().getAuthenticatedUser();
        if(user){
            user.token = user?.stsTokenManager?.accessToken;
        }
        return user;
    }

    /** Jeton Firebase à jour (renouvelé automatiquement), null si déconnecté */
    public getIdToken(): Promise<string | null> {
        const backend = getFirebaseBackend();
        return backend ? backend.getIdToken() : Promise.resolve(null);
    }

    /** Nouveau jeton (rôle et ferme à jour après une invitation acceptée) */
    public rafraichirJeton(): Promise<any> { return getFirebaseBackend().rafraichirJeton(); }

    /** Claims du jeton : null ou sans « tenant » = compte sans ferme */
    public claims(): Promise<any> { return getFirebaseBackend().claims(); }

    public nomAffiche(nom: string): Promise<void> { return getFirebaseBackend().nomAffiche(nom); }

    /**
     * Performs the auth
     * @param email email of user
     * @param password password of user
     */
    login(email: string, password: string) {
        return getFirebaseBackend().loginUser(email, password).then((response: any) => {
            const user = response;
            return user;
        });
    }

    /**
     * Performs the register
     * @param email email
     * @param password password
     */
    register(email: string, password: string) {
        return getFirebaseBackend().registerUser(email, password).then((response: any) => {
            const user = response;
            return user;
        });
    }

    registerWithRole(email: string, password: string, userRole: string, displayName: string) {
        return getFirebaseBackend().registerUser(email, password).then((response: any) => {
            const user = response;
            getFirebaseBackend().setCustomUserClaims(user.uid, { role : userRole });

            
            user.updateProfile({
                displayName: displayName,
              }).then(() => {
                console.log('good');
              }, (error) => {
               console.log(error);
              });
              
            
            return user;
        });
    }

    /**
     * Reset password
     * @param email email
     */
    resetPassword(email: string) {
        return getFirebaseBackend().forgetPassword(email).then((response: any) => {
            const message = response.data;
            return message;
        });
    }

    /**
     * Logout the user
     */
    logout() {
        // logout the user
        return getFirebaseBackend().logout();
    }
}

